import { motion } from "framer-motion";
import cardBox from "./card.module.scss";
import cardStates from "./cardStates.module.scss";
import clsx from "clsx";

import { useGameSounds } from "@educaplay/core";
import {
  LINE_UP_SOUND_NAMES,
  CARD_CORRECTIONS,
  CARD_STATES,
} from "../../utils/consts";
import { useSelector } from "react-redux";
import { SCREENS } from "@educaplay/store/constants";

// Condition jumping
function cardStateSelector({
  checkLock,
  isCorrect,
  active,
  isDragging,
  atOverlay,
  hasFinished,
}) {
  if (atOverlay) {
    return cardStates.overlayed;
  } else if (isCorrect) {
    return cardStates.ok; // Locked, no interactable, can place bounce because there are no more animations
  } else if (checkLock || hasFinished) {
    return cardStates.defaultNoInteract; // default, but with no hover / active
  } else if (isDragging) {
    return cardStates.ghosted; // invisible because overlaying, jumps active (dragged card is active, logic-wise)
  } else if (active) {
    return cardStates.active; // selecting by other means (keyboard, tapping)
  } else {
    return cardStates.default;
  }
}
function cardSizeSelector(nCards) {
  if (nCards <= 4) return cardBox.cardS4Size;
  else if (nCards <= 6) return cardBox.card56Size;
  else return cardBox.card7PSize;
}

export default function AnimatedCard(props) {
  const {
    children,
    locked,
    active,
    correction,
    checkLock,
    isDragging,
    atOverlay,
  } = props;

  const gameSounds = useGameSounds();
  const hasFinished =
    useSelector((state) => state.game.view) === SCREENS.SCORE_SCREEN;

  const questions = useSelector((state) => state.game.questions);
  const currentQuestionIndex = useSelector((state) => state.game.currentIndex);
  const currentQuestion = questions[currentQuestionIndex];
  const listSize = currentQuestion.items.length;

  const cardStateCN = cardStateSelector({
    checkLock,
    isCorrect: locked,
    active,
    isDragging,
    atOverlay,
    hasFinished,
  });

  const cardSizeCN = cardSizeSelector(listSize);

  // Along with card colors, --fillPlayer and --fillMusic will go through all elements
  // These CSS variables will be applied to the music player and music icon
  // We can animate all colors at once using this method
  return (
    <motion.div
      initial={{
        "--fillPlayer": "var(--primary-color)",
        "--fillMusic": "var(--primary-color)",
      }}
      className={clsx(cardBox.card, cardBox.cardBorder, cardSizeCN)}
      animate={CARD_STATES.default}
      data-animate-id={correction}
    >
      <motion.div
        onHoverStart={() => {
          if (!active && correction !== CARD_CORRECTIONS.locked) {
            gameSounds.play(LINE_UP_SOUND_NAMES.hoverCard);
          }
        }}
        className={clsx(cardBox.contentContainer, cardStateCN)}
      >
        {children}
      </motion.div>
    </motion.div>
  );
}
